import { render, staticRenderFns } from "./TransactionalNotificationModal.vue?vue&type=template&id=215d2e02&scoped=true&"
import script from "./TransactionalNotificationModal.vue?vue&type=script&lang=js&"
export * from "./TransactionalNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionalNotificationModal.vue?vue&type=style&index=0&id=215d2e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d2e02",
  null
  
)

export default component.exports